export const environment = {
	production: true,
	url: 'https://api.dev-installer.kosaas-mmi.com:3002'
};
